<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group">
                <label>ANNO</label>
                <select class="form-control form-control-sm" v-model="search.ANNO_PROTOCOLLO.VALUE">
                    <option value="">Qualsiasi</option>
                    <option v-for="anno in this.anni" v-bind:value="anno" v-bind:key="anno">
                    {{ anno }}
                    </option>
                </select>
            </div>
            <div class="form-group ">
                <label>NOTE</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Titolo" type="text" style="width:200px" v-model="search.NOTE.VALUE">
            </div>
            <div class="form-group">
                <label>Categoria</label>
                <select class="form-control form-control-sm" v-model="search.CATEGORIA.VALUE">
                    <option value="">Qualsiasi</option>
                    <option value="1-AGRICOLTURA">1-AGRICOLTURA</option>
                    <option value="2-AMMINISTRAZIONE">2-AMMINISTRAZIONE</option>
                    <option value="3- BOSCHI">3- BOSCHI</option>
                    <option value="4-CONTRIBUTI">4-CONTRIBUTI</option>
                    <option value="5-VUOTA">5-VUOTA</option>
                    <option value="6-FINANZE">6-FINANZE</option>
                    <option value="7-LOCAZIONI E CONDUZIONI">7-LOCAZIONI E CONDUZIONI</option>
                </select>
            </div>
            <button v-if="false" class="btn btn-success float-right my-2 my-sm-3 mt-4 btn-sm" v-on:click="caricaAllegato()"><i class="fas fa-plus"></i> Nuovo Protocollo</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #a9a9a9;color:#fff">
                    <th  style="width:5%"><span >ID</span></th>
                    <th  style="width:5%"><span >ANNO</span></th>
                    <th  style="width:5%"><span >NUMERO</span></th>
                    <th  style="width:10%"><span >TIPO</span></th>
                    <th  style="width:15%"><span >CATEGORIA</span></th>
                    <th  style="width:25%"><span >NOME FILE</span></th>
                    <th  style="width:10%"><span >DATA CARICAMENTO</span></th>
                    <th  style="width:20%"><span >NOTE</span></th>
                    <th  style="width:5%"><span >AZIONI</span></th>
                    
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="protocollo.ID_ALLEGATO"  v-for="protocollo in paginatedList.arr">                        
                    <td  style="width:5%;font-size:16px">
                        {{ protocollo.ID_ALLEGATO }}
                    </td>
                    <td  style="width:5%">
                        {{ protocollo.ANNO_PROTOCOLLO }}
                    </td>
                    <td  style="width:5%">
                        {{ protocollo.NUMERO_PROTOCOLLO }}
                    </td>
                    <td  style="width:10%">
                        <span v-if="protocollo.TIPO" class='badge badge-info'>USCITA</span>
                        <span v-if="protocollo.TIPO == 0" class='badge badge-primary'>ENTRATA</span>                      
                    </td>          
                    <td  style="width:15%">
                        {{ protocollo.CATEGORIA }}
                    </td>
                    <td  style="width:25%">
                        {{ protocollo.NOME_FILE }}
                    </td>
                    <td  style="width:10%">
                        {{filters.formatDate(protocollo.DATA_CARICAMENTO)}}
                    </td>
                    <td  style="width:20%">
                        {{ protocollo.NOTE }}
                    </td>
                    <td  style="width:15%">
                        <button v-on:click="openAllegato(protocollo.ID_ALLEGATO)" class="btn btn-info float-right"><i class="fas fa-download"></i></button>
                    </td>
                    
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>

    <div class="modal fade" :id="'popUpAllegato'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header" style="background:#629991">
                    <h4 style="color:#fff" class="modal-title"><i class="fas fa-paperclip fa-fw"></i> Allegato</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:550px">
                    <div class="row">
                        <div class="col-6">
                            <form>
                                <div class="form-group">
                                    <label >Note</label>
                                    <textarea class="form-control form-control-sm" rows="11" placeholder="Inserisci le tue note qui..." v-model="argsUpload.NOTE"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label >Genera contestualmente numero protocollo</label>
                                    <input class="form-control form-control-sm" style="width:20px;height:20px" type="checkbox" v-model="argsUpload.FLG_ASSEGNA_PROTOCOLLO" v-bind:true-value="1" v-bind:false-value="0">
                                </div>
                                <div v-if="argsUpload.FLG_ASSEGNA_PROTOCOLLO" class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Tipologia</label>
                                    <select class="form-control " v-model="argsUpload.TIPO">
                                        <option value="0">ENTRATA</option>
                                        <option value="1">USCITA</option>
                                    </select>
                                </div> 
                            </form>
                        </div>
                        <div class="col-6">
                            <Upload @onsuccess="successCaricamento()" :w="90" :args="argsUpload"></Upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import Upload from '@/components/utils/Upload.vue'
import Pagine from '@/components/utils/Pagine.vue'


export default {
    name:"Protocollo",
    components:{
        Pagine,
        Upload
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                ANNO_PROTOCOLLO:{TYPE:'COMBO',VALUE:'2024'}, 
                NOTE:{TYPE:'TEXT',VALUE:''},
                CATEGORIA:{TYPE:'COMBO',VALUE:''},                 
            },        
        
            arrayProtocolli:new Array(),
            anni:new Array(),
            argsUpload : {modalita:'EMMET_uploadAllegato'},
        
        }
    },
    methods: {
        getProtocolli : function(){
            global.utils.get('/emmet/protocolli', { ordinamento: 'DESC' }, (response) => {       
                this.arrayProtocolli = (response.data || []).sort((a, b) => Number(b.ID_ALLEGATO) - Number(a.ID_ALLEGATO));
                for (var i=0; i<this.arrayProtocolli.length; i++){
                    if (!this.anni.includes(this.arrayProtocolli[i].ANNO_PROTOCOLLO)){
                        this.anni.push(this.arrayProtocolli[i].ANNO_PROTOCOLLO);
                    }
                }
                this.search.ANNO_PROTOCOLLO.VALUE  = new Date().getFullYear();
            });
        },
        openAllegato : function(idAllegato){
            window.open(global.utils.BASE_API + "core/report?ID_REPORT=1001&ID_ALLEGATO="+idAllegato+"&SESSION_TOKEN="+utils.SESSION_TOKEN);
        },
        caricaAllegato : function(){
            this.argsUpload.FK_ID_PRATICA = 0;
            this.argsUpload.NOTE = "";
            this.argsUpload.FLG_ASSEGNA_PROTOCOLLO = 0;
            this.argsUpload.TIPO = 0;
            this.argsUpload.CATEGORIA = "";
            utils.openModal('popUpAllegato'+this.ts);
        },
        successCaricamento : function(){
            this.getProtocolli();
            utils.closeModal('popUpAllegato'+this.ts);
        },
        
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayProtocolli,this.search);
            return arr;
        }, 
    },
    created : function(){
       this.getProtocolli(); 
    },

}


</script>
